function produktuarenDatuak(produktua) {
    $.get('/produktuak/' + produktua, function (data) {
        $('#produktua').val(data.produktua);
        $('#ref_originala').val(data.ref_originala);
        $('#ref_enpresa').val(data.ref_enpresa);
        $('#barrakodea').val(data.barrakodea);
        $('#salmentaPrezioa').val(data.salmentaPrezioa);
        $('#bezMota').val(data.bezMota);
    });
}